import { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import Logo from '../assets/images/logo/logo.svg'
import LogoWhite from '../assets/images/logo/logo_cn_wh.svg'
import LogInIcon from '../assets/images/common/ico_user.svg'
import MenuIcon from '../assets/images/common/menu-icon.svg'
import CloseIcon from '../assets/images/common/close-white.svg'
import TalkTalkIcon from '../assets/images/main/bookmark12.svg'

import { bookmarkList } from '../assets/data'
import { Gasang, GreenFootPrint } from './PopUp'

import { useLocation } from 'react-router-dom'
import { userState } from 'stores/userState'
import { useRecoilValue, useSetRecoilState } from 'recoil'
import { getUserTypeName } from 'types/type'
import { CHAT_URL } from 'views/Main'
import { chatWindowState } from 'stores/chatWindowState'
import { jwtTokenState } from 'stores/jwtTokenState'
export default function Header() {
  const location = useLocation()
  const [isMobileClick, setIsMobileClick] = useState(false)
  const [gasangOpen, setGasangOpen] = useState(false)
  const [greenFootPrintOpen, setGreenFootPrintOpen] = useState(false)
  const user = useRecoilValue(userState)
  const setChatWindow = useSetRecoilState(chatWindowState)
  // const [openGasang, setOpenGasang] = useState(false)
  const jwtToken = useRecoilValue(jwtTokenState)
  const navigate = useNavigate()

  const openPopUp = (setPopUpOpen) => {
    if (!setPopUpOpen) return
    setPopUpOpen(true)
  }

  const handleClickLogo = () => {
    navigate('/')
  }

  const onLogoutButtonClick = () => {
    window.location.href = '/logout'
  }

  const onLoginButtonClick = () => {
    window.location.href = '/login'
  }

  return (
    <div className='w-full'>
      {!isMobileClick && (
        <div className='flex p-20 h-[70px] border-solid border-b-[1px] gap-10 items-center justify-between border-default-border bg-default-white'>
          <div className='flex items-center gap-8 sm:gap-[15px]'>
            <img
              onClick={handleClickLogo}
              className='w-80 h-[24px] sm:w-[115px] sm:h-[34px] cursor-pointer'
              src={Logo}
              alt=''
            />
            <div className='hidden sm:block h-20 w-[1px] bg-default-border' />
            <p
              className='text-[14px] hidden sm:block font-[700] sm:text-header-title text-default-black'
              style={{ overflowWrap: 'break-word', wordBreak: 'keep-all' }}
            >
              충남교육청 미래교육 통합플랫폼
            </p>
          </div>
          <div className='flex items-center gap-8 shrink-0'>
            {location.pathname === '/' && (
              <div className='items-center gap-16 flex'>
                {user.isLogin && (
                  <>
                    <div className='md:flex hidden items-center gap-16'>
                      {user.name && (
                        <p className='text-[12px] text-default-header'>
                          반갑습니다.{' '}
                          <span className=' text-default-black font-semibold'>{user.name}</span>{' '}
                          {getUserTypeName(user.userType)}
                        </p>
                      )}
                      <div className='h-[13px] w-[1px] bg-default-border' />
                      {user.school && (
                        <p className='text-[12px] text-default-header'>{user.school}</p>
                      )}
                    </div>
                    <div className='md:hidden flex flex-col items-center gap-4'>
                      {user.school && (
                        <p className='text-[12px] text-default-header'>{user.school}</p>
                      )}
                      {user.name && (
                        <p className='text-[12px] text-default-header'>
                          <span className=' text-default-black font-semibold'>{user.name}</span>{' '}
                          {getUserTypeName(user.userType)}
                        </p>
                      )}
                    </div>
                  </>
                )}
                <div className='flex items-center gap-10'>
                  {user.isLogin ? (
                    <button
                      onClick={onLogoutButtonClick}
                      className='flex items-center px-10 sm:px-20 bg-default-white border-[1px] border-solid border-[#d6dbe4] rounded-32 h-30'
                    >
                      <img src={LogInIcon} alt='' />
                      <p className='text-[12px]'>로그아웃</p>
                    </button>
                  ) : (
                    <button
                      onClick={onLoginButtonClick}
                      className='flex items-center px-10 sm:px-20 bg-default-white border-[1px] border-solid border-[#d6dbe4] rounded-32 h-30'
                    >
                      <img src={LogInIcon} alt='' />
                      <p className='text-[12px]'>로그인</p>
                    </button>
                  )}
                </div>
              </div>
            )}
            <img
              onClick={() => setIsMobileClick((prev) => !prev)}
              className='w-40 h-40 xl:hidden'
              src={MenuIcon}
              alt=''
            />
          </div>
        </div>
      )}
      {isMobileClick && (
        <div className='bg-[#004998] px-[15px] py-[60px] flex flex-col items-center gap-[100px] w-full h-full fixed top-0 z-50'>
          <img
            className='absolute w-40 h-40 top-20 right-20'
            onClick={() => setIsMobileClick((prev) => !prev)}
            src={CloseIcon}
            alt=''
          />
          <div className='grid justify-between w-full grid-cols-4 md:grid-cols-6 gap-y-20'>
            {bookmarkList.map((bookmarkItem, bookmarkIndex) => (
              <div key={bookmarkIndex}>
                {bookmarkItem.id === 12 ? (
                  <div
                    className='flex flex-col items-center justify-center gap-10'
                    onClick={() => {
                      const chatWindow = window.open(CHAT_URL + '?token=' + jwtToken, '_blank')
                      chatWindow.opener = window
                      setChatWindow({ window: chatWindow })
                      // console.log(chatWindow)
                    }}
                  >
                    <div className='p-16 rounded-10 bg-[#f5f5f5] flex items-center justify-center'>
                      <img className='w-30 h-30' src={TalkTalkIcon} alt='' />
                    </div>
                    <p className='text-[12px] text-default-white'>{bookmarkItem.title}</p>
                  </div>
                ) : (
                  <Link key={bookmarkIndex} to={bookmarkItem.link} target={bookmarkItem.target}>
                    <div
                      className='flex flex-col items-center justify-center gap-10'
                      onClick={() => {
                        openPopUp(
                          // bookmarkItem.id === 8
                          //   ? setGasangOpen
                          //   :
                          bookmarkItem.id === 9 ? setGreenFootPrintOpen : null
                        )
                      }}
                    >
                      <div className='p-16 rounded-10 bg-[#f5f5f5] flex items-center justify-center'>
                        <img className='w-30 h-30' src={bookmarkItem.logo} alt='' />
                      </div>
                      <p className='text-[12px] text-default-white'>{bookmarkItem.title}</p>
                    </div>
                  </Link>
                )}
                {/* {bookmarkItem.popUp} */}
                {bookmarkItem.id === 8 && gasangOpen && <Gasang setModalOpen={setGasangOpen} />}
                {bookmarkItem.id === 9 && greenFootPrintOpen && (
                  <GreenFootPrint setModalOpen={setGreenFootPrintOpen} />
                )}
              </div>
            ))}
          </div>
          <img className='flex items-center' src={LogoWhite} alt='' />
        </div>
      )}
    </div>
  )
}
